<template>
  <div>
    <div class="loader" v-if="isLoading"></div>
    <div class="loadertext" v-if="isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': isLoading }">
      <sidebar-component classMenu="Rute"></sidebar-component>

      <div class="page-wrapper">
        <navbar-component></navbar-component>

        <div class="page-content">
          <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <!-- <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">Master Margin Estimasi</h4>
                  <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px" @click.prevent="createData">
                    <i class="link-icon" data-feather="plus"></i>
                    {{ $t("createNew") }}
                  </button>
                </div> -->

                <div class="card-body">

                  <!-- HEADER ACTION -->
                  <div class="d-flex justify-content-between align-items-center mb-3 mt-5">
                    <div>
                      <h5 class="mb-0 fw-semibold text-dark">Data Margin Estimasi</h5>
                      <small class="text-muted">List data margin estimasi customer</small>
                    </div>

                    <div>
                      <button v-if="permision_role.method_create" class="btn btn-primary btn-sm" @click="createData">
                        <i class="mdi mdi-plus"></i> Tambah
                      </button>
                    </div>
                  </div>

                  <!-- TABLE -->
                  <div class="modern-table-wrapper">

                    <table class="modern-table table align-middle">
                      <thead>
                        <tr>
                          <th v-for="col in columns" :key="col.field" @click="handleSort(col)">
                            <div class="d-flex align-items-center gap-1">
                              {{ col.label }}
                              <span v-if="serverParams.sort.field === col.field">
                                {{ serverParams.sort.type === 'asc' ? '▲' : '▼' }}
                              </span>
                            </div>
                          </th>
                        </tr>

                        <tr>
                          <th v-for="col in columns" :key="col.field">
                            <input v-if="col.filterOptions && col.filterOptions.enabled"
                              v-model="serverParams.columnFilters[col.field]" @keyup.enter="triggerFilter"
                              :placeholder="col.filterOptions.placeholder" class="form-control form-control-sm" />
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-if="isLoading">
                          <td :colspan="columns.length" class="text-center py-4">
                            <div class="spinner-border spinner-border-sm text-primary"></div>
                            <div class="text-muted mt-1">Loading data...</div>
                          </td>
                        </tr>

                        <tr v-for="row in rows" :key="row.transport_order_margin_estimasi_id">
                          <td v-for="col in columns" :key="col.field">

                            <span v-if="['min_value', 'max_value'].includes(col.field)">
                              {{ formatNumber(row[col.field]) }}
                            </span>

                            <span v-else-if="col.field === 'actions'">
                              <button class="btn btn-light btn-sm me-1" @click="detailData(row)">
                                <i class="mdi mdi-eye text-primary"></i>
                              </button>

                              <button v-if="permision_role.method_update" class="btn btn-light btn-sm"
                                @click="editData(row)">
                                <i class="mdi mdi-pencil text-warning"></i>
                              </button>
                            </span>

                            <span v-else>
                              {{ row[col.field] || '-' }}
                            </span>

                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>

                  <!-- FOOTER -->
                  <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">

                    <!-- LEFT: TOTAL + PER PAGE -->
                    <div class="d-flex align-items-center gap-2">
                      <small class="text-muted">
                        Total: {{ totalRecords }}
                      </small>

                      <select class="form-select form-select-sm w-auto" v-model="serverParams.per_page"
                        @change="changePerPage">
                        <option :value="10">10</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                        <option :value="200">200</option>
                      </select>

                      <small class="text-muted">per page</small>
                    </div>

                    <!-- RIGHT: PAGINATION -->
                    <div>

                      <small class="text-muted">
                          Showing 
                          {{ (serverParams.page - 1) * serverParams.per_page + 1 }} 
                          -
                          {{ Math.min(serverParams.page * serverParams.per_page, totalRecords) }} 
                          of {{ totalRecords }}
                        </small>

                      <button class="btn btn-outline-secondary btn-sm me-2" @click="changePage(serverParams.page - 1)"
                        :disabled="serverParams.page === 1">
                        Prev
                      </button>

                      <span class="fw-semibold">Page {{ serverParams.page }}</span>

                      <button class="btn btn-outline-secondary btn-sm ms-2" @click="changePage(serverParams.page + 1)">
                        Next
                      </button>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <footer-component></footer-component>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "MarginEstimasiList",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      isLoading: false,
      errors: [],
      permision_role: [],
      detailUser: [],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "transport_order_margin_estimasi_id",
          type: "desc",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: "Customer Code",
          field: "customer_code",
          filterOptions: {
            enabled: true,
            placeholder: "Filter By Customer Code",
            filterValue: "",
            trigger: "enter",
          },
        },
        {
          label: "Customer Name",
          field: "customer_name",
          filterOptions: {
            enabled: true,
            placeholder: "Filter By Customer Name",
            filterValue: "",
            trigger: "enter",
          },
        },
        {
          label: "Pick Location",
          field: "pick_location",
          filterOptions: {
            enabled: true,
            placeholder: "Filter By Pick Location",
            filterValue: "",
            trigger: "enter",
          },
        },
        {
          label: "Drop Location",
          field: "drop_location",
          filterOptions: {
            enabled: true,
            placeholder: "Filter By Drop Location",
            filterValue: "",
            trigger: "enter",
          },
        },
        {
          label: "Truck Type",
          field: "type_truck",
          filterOptions: {
            enabled: true,
            placeholder: "Filter By Truck Type",
            filterValue: "",
            trigger: "enter",
          },
        },
        {
          label: "Carrier",
          field: "carrier",
          filterOptions: {
            enabled: true,
            placeholder: "Filter By Carrier",
            filterValue: "",
            trigger: "enter",
          },
        },
        // {
        //   label: "Billable Tariff",
        //   field: "billable_tariff",
        //   filterOptions: {
        //     enabled: true,
        //     placeholder: "Filter By Billable Tariff",
        //     filterValue: "",
        //     trigger: "enter",
        //   },
        // },
        {
          label: "Charge Code",
          field: "charge_code",
        },
        {
          label: "Min Value",
          field: "min_value",
          filterOptions: {
            enabled: true,
            placeholder: "Filter By Min Value",
            filterValue: "",
            trigger: "enter",
          },
        },
        {
          label: "Max Value",
          field: "max_value",
          filterOptions: {
            enabled: true,
            placeholder: "Filter By Max Value",
            filterValue: "",
            trigger: "enter",
          },
        },
        // {
        //   label: "Min Percent",
        //   field: "min_percent",
        //   filterOptions: {
        //     enabled: true,
        //     placeholder: "Filter By Min Percent",
        //     filterValue: "",
        //     trigger: "enter",
        //   },
        // },
        // {
        //   label: "Max Percent",
        //   field: "max_percent",
        //   filterOptions: {
        //     enabled: true,
        //     placeholder: "Filter By Max Percent",
        //     filterValue: "",
        //     trigger: "enter",
        //   },
        // },
        {
          label: "Action",
          field: "actions",
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.fetchIt();
    this.loadItems();

  },
  methods: {
    changePerPage() {
      this.serverParams.page = 1; // reset ke page 1
      this.loadItems();
    },
    handleSort(col) {
      if (!col.field || col.field === 'actions') return;

      if (this.serverParams.sort.field === col.field) {
        this.serverParams.sort.type =
          this.serverParams.sort.type === 'asc' ? 'desc' : 'asc';
      } else {
        this.serverParams.sort.field = col.field;
        this.serverParams.sort.type = 'asc';
      }

      this.loadItems();
    },

    triggerFilter() {
      this.serverParams.page = 1;
      this.loadItems();
    },

    changePage(page) {
      if (page < 1) return;
      this.serverParams.page = page;
      this.loadItems();
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      let rolePermision = [];

      userDatas.sub.permision_role.forEach((permision) => {
        if (permision.permission.controller === "TransportOrderMarginEstimasiController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
        return;
      }

      this.permision_role = rolePermision;
    },

    createData() {
      this.$router.push("/master-margin-estimasi/add");
    },

    detailData(row) {
      this.$router.push(
        "/master-margin-estimasi/detail/" + row.transport_order_margin_estimasi_id
      );
    },

    editData(row) {
      this.$router.push(
        "/master-margin-estimasi/edit/" + row.transport_order_margin_estimasi_id
      );
    },

    deleteData(row) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: "Hapus data margin estimasi ini?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (!result.value) {
          return;
        }

        const baseURI =
          this.$settings.endPoint +
          "transport-order-margin-estimasi/delete/" +
          row.transport_order_margin_estimasi_id;

        this.isLoading = true;
        this.$http
          .delete(baseURI)
          .then((response) => {
            this.isLoading = false;
            if (response.data.status === 200) {
              this.success(response.data?.datas?.messages || "Data berhasil dihapus");
              this.loadItems();
            } else {
              this.resultError(response.data.errors || {});
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.handleHttpError(error);
          });
      });
    },

    loadItems() {
      const filters = this.serverParams.columnFilters || {};
      const params = new URLSearchParams({
        limit: this.serverParams.per_page,
        page: this.serverParams.page,
        sort_field: this.serverParams.sort.field || "",
        sort_type: this.serverParams.sort.type || "",
        customer_code: filters.customer_code || "",
        customer_name: filters.customer_name || "",
        pick_location: filters.pick_location || "",
        drop_location: filters.drop_location || "",
        type_truck: filters.type_truck || "",
        carrier: filters.carrier || "",
        billable_tariff: filters.billable_tariff || "",
        min_value: filters.min_value || "",
        max_value: filters.max_value || "",
        min_percent: filters.min_percent || "",
        max_percent: filters.max_percent || "",
      });

      const baseURI = this.$settings.endPoint + "transport-order-margin-estimasi";
      this.isLoading = true;

      return this.$http
        .get(baseURI + "?" + params.toString(), { timeout: 10000 })
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data?.datas?.data || [];
          this.totalRecords = response.data?.datas?.total || 0;
        })
        .catch((error) => {
          this.isLoading = false;
          this.handleHttpError(error);
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams({
        columnFilters: params.columnFilters || {},
        page: 1,
      });
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage, page: 1 });
    },

    formatNumber(value) {
      return Number(value || 0).toLocaleString("id-ID");
    },

    resultError(data) {
      const keys = Object.keys(data || {});
      if (!keys.length) {
        this.error("Terjadi kesalahan saat memproses data.");
        return;
      }

      keys.forEach((key) => {
        const messages = Array.isArray(data[key]) ? data[key] : [data[key]];
        messages.forEach((message) => this.error(message));
      });
    },

    handleHttpError(error) {
      if (error.code === "ECONNABORTED") {
        this.error(this.$t("check_internet_connection_txt"));
        return;
      }

      if (!error.response) {
        this.error("Terjadi kesalahan pada koneksi.");
        return;
      }

      if (error.response.status === 422) {
        this.errors = error.response.data.errors;
        this.resultError(error.response.data.errors);
      } else if (error.response.status === 500) {
        this.$router.push("/server-error");
      } else if (error.response.status === 401) {
        this.$router.push("/authorized-error");
      } else {
        this.$router.push("/page-not-found");
      }
    },

    success(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: message,
      });
    },

    error(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "error",
        title: message,
      });
    },
  },
};


</script>


<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}


.modern-table-wrapper {
  max-height: 500px;
  overflow: auto;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

/* HEADER */
.modern-table thead th {
  position: sticky;
  background: #f8f9fb;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  padding: 10px;
  z-index: 10;
}

/* HEADER ROW */
.modern-table thead tr:first-child th {
  top: 0;
}

/* FILTER ROW */
.modern-table thead tr:nth-child(2) th {
  top: 37px;
  background: #ffffff;
}

/* INPUT */
.modern-table thead input {
  font-size: 12px;
  padding: 4px 6px;
}

/* BODY */
.modern-table tbody td {
  font-size: 13px;
  color: #212529;
  padding: 10px;
}

/* HOVER */
.modern-table tbody tr:hover {
  background-color: #f1f3f5;
}

/* BUTTON FIX */
.btn-light {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}

.btn-light:hover {
  background: #e9ecef;
}

/* SCROLLBAR (BIAR MODERN) */
.modern-table-wrapper::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.modern-table-wrapper::-webkit-scrollbar-thumb {
  background: #ced4da;
  border-radius: 10px;
}
</style>